// extracted by mini-css-extract-plugin
module.exports = {"theme":"Tabs_theme__Fe30F","themeActive":"Tabs_themeActive__MBhQG","themeHover":"Tabs_themeHover__6BExd"};